import i18n from "@Shared/@i18n";
import { APPLICATION_FLOW, APPLICANT_MARITAL_STATUS, PROPERTY_GARAGE_SIZE, PROPERTY_OCCUPANCY_TYPE, PROPERTY_STYLE, PROPERTY_TYPE, APPLICANT_SALUTATION, APPLICANT_RELATIONSHIP, APPLICANT_TYPE, APPLICANT_LIVING_SITUATION, APPLICANT_LANGUAGE_PREFERENCE, APPLICANT_IDENTIFICATION_TYPE, APPLICANT_OPERATING_AS, APPLICANT_EMPLOYMENT_TYPE, APPLICANT_OCCUPATION, APPLICANT_INCOME_TYPE, APPLICANT_INDUSTRY_SECTOR, APPLICANT_INCOME_PERIOD, ADDITIONAL_INCOME_TYPE, ASSET_TYPE, LIABILITY_TYPE, LIABILITY_PAYOFF, MORTGAGE_DOWNPAYMENT_SOURCE, MORTGAGE_REQUESTED_TYPE, MORTGAGE_LOAN_TYPE, MORTGAGE_TYPE, MORTGAGE_LINE_OF_BUSINESS, MORTGAGE_LOC_REPAYMENT, MORTGAGE_RATE_TYPE, MORTGAGE_TERM_TYPE, MORTGAGE_FREQUENCY, MORTGAGE_COMPOUNDING_PERIOD, MORTGAGE_NOTE_CATEGORY, MORTGAGE_PAYOFF, MORTGAGE_INSURANCE_PROVIDER, PROPERTY_CONSTRUCTION_TYPE, PROPERTY_TENURE, PROPERTY_UNIT_OF_MEASUREMENT, PROPERTY_GARAGE_STYLE, PROPERTY_HEATING_TYPE, PROPERTY_WATER_INFORMATION, PROPERTY_SEWAGE_TYPE, PROPERTY_TAX_RESPONSIBLE, PROPERTY_RENTAL_INCOME, PROPERTY_VALUE_INDEX, CANADA_PROVINCE } from "@Shared/@Types/application/application-enums";
export const APPLICATION_FIELD_OPTIONS = () => ({
  firstFlowSelectionOptions: [{
    value: APPLICATION_FLOW.PURCHASE,
    label: i18n.t("application-standalone.options.flows.purchase")
  }, {
    value: APPLICATION_FLOW.REFINANCE,
    label: i18n.t("application-standalone.options.flows.refinance")
  }, {
    value: APPLICATION_FLOW.SWITCH_TRANSFER,
    label: i18n.t("application-standalone.options.flows.switchTransfer")
  }],
  secondFlowSelectionOptions: [{
    value: APPLICATION_FLOW.PURCHASE,
    label: i18n.t("application-standalone.options.flows.foundAHome")
  }, {
    value: APPLICATION_FLOW.PRE_APPROVAL,
    label: i18n.t("application-standalone.options.flows.searching")
  }],
  salutationOptions: [{
    value: APPLICANT_SALUTATION.MR,
    label: i18n.t("application-form.mr")
  }, {
    value: APPLICANT_SALUTATION.MRS,
    label: i18n.t("application-form.mrs")
  }, {
    value: APPLICANT_SALUTATION.MS,
    label: i18n.t("application-form.ms")
  }, {
    value: APPLICANT_SALUTATION.DR,
    label: i18n.t("application-form.dr")
  }, {
    value: APPLICANT_SALUTATION.REV,
    label: i18n.t("application-form.rev")
  }, {
    value: APPLICANT_SALUTATION.MISS,
    label: i18n.t("application-form.miss")
  }, {
    value: APPLICANT_SALUTATION.JUDGE,
    label: i18n.t("application-form.judge")
  }],
  propertyDetailsOccupancyOptions: [{
    value: PROPERTY_OCCUPANCY_TYPE.OWNER_OCCUPIED,
    label: i18n.t("application-form.owner-occupied")
  }, {
    value: PROPERTY_OCCUPANCY_TYPE.OWNER_OCCUPIED_AND_RENTAL,
    label: i18n.t("application-form.owner-occupied-and-rental")
  }, {
    value: PROPERTY_OCCUPANCY_TYPE.RENTAL,
    label: i18n.t("application-form.rental")
  }, {
    value: PROPERTY_OCCUPANCY_TYPE.SECOND_HOME,
    label: i18n.t("application-form.second-home")
  }],
  propertyStyleOptions: [{
    value: PROPERTY_STYLE.ONE_STOREY,
    label: i18n.t("application-form.one-storey")
  }, {
    value: PROPERTY_STYLE.BI_LEVEL,
    label: i18n.t("application-form.bi-level")
  }, {
    value: PROPERTY_STYLE.TWO_STOREY,
    label: i18n.t("application-form.two-storey")
  }, {
    value: PROPERTY_STYLE.SPLIT_LEVEL,
    label: i18n.t("application-form.split-level")
  }, {
    value: PROPERTY_STYLE.STOREY_AND_A_HALF,
    label: i18n.t("application-form.storey-and-a-half")
  }, {
    value: PROPERTY_STYLE.THREE_STOREY,
    label: i18n.t("application-form.three-storey")
  }, {
    value: PROPERTY_STYLE.OTHER,
    label: i18n.t("application-form.other")
  }],
  propertyTypeOptions: [{
    value: PROPERTY_TYPE.DETACHED,
    label: i18n.t("application-form.detached")
  }, {
    value: PROPERTY_TYPE.SEMI_DETACHED,
    label: i18n.t("application-form.semi-detached")
  }, {
    value: PROPERTY_TYPE.ROW_HOUSING,
    label: i18n.t("application-form.row-housing")
  }, {
    value: PROPERTY_TYPE.DUPLEX_DETACHED,
    label: i18n.t("application-form.duplex-detached")
  }, {
    value: PROPERTY_TYPE.APARTMENT_LOW_RISE,
    label: i18n.t("application-form.apartment-low-rise")
  }, {
    value: PROPERTY_TYPE.APARTMENT_HIGH_RISE,
    label: i18n.t("application-form.apartment-high-rise")
  }, {
    value: PROPERTY_TYPE.MOBILE,
    label: i18n.t("application-form.mobile")
  }, {
    value: PROPERTY_TYPE.STACKED,
    label: i18n.t("application-form.stacked")
  }],
  propertyGarageStyleOptions: [{
    label: i18n.t("application-form.attached"),
    value: PROPERTY_GARAGE_STYLE.ATTACHED
  }, {
    label: i18n.t("application-form.detached"),
    value: PROPERTY_GARAGE_STYLE.DETACHED
  }],
  propertyGarageSizeOptions: [{
    value: PROPERTY_GARAGE_SIZE.SINGLE,
    label: i18n.t("application-form.single")
  }, {
    value: PROPERTY_GARAGE_SIZE.DOUBLE,
    label: i18n.t("application-form.double")
  }, {
    value: PROPERTY_GARAGE_SIZE.TRIPLE,
    label: i18n.t("application-form.triple")
  }, {
    value: PROPERTY_GARAGE_SIZE.NONE,
    label: i18n.t("application-form.none")
  }],
  propertyConstructionTypeOptions: [{
    label: i18n.t("application-form.existing"),
    value: PROPERTY_CONSTRUCTION_TYPE.EXISTING
  }, {
    label: i18n.t("application-form.new"),
    value: PROPERTY_CONSTRUCTION_TYPE.NEW
  }],
  propertyTenureOptions: [{
    label: i18n.t("application-form.freehold"),
    value: PROPERTY_TENURE.FREEHOLD
  }, {
    label: i18n.t("application-form.leasehold"),
    value: PROPERTY_TENURE.LEASEHOLD
  }, {
    label: i18n.t("application-form.condo"),
    value: PROPERTY_TENURE.CONDO
  }],
  propertyUnitOfMeasurementOptions: [{
    label: i18n.t("application-form.sqFt"),
    value: PROPERTY_UNIT_OF_MEASUREMENT.SQ_FT
  }, {
    label: i18n.t("application-form.sqM"),
    value: PROPERTY_UNIT_OF_MEASUREMENT.SQ_M
  }, {
    label: i18n.t("application-form.acres"),
    value: PROPERTY_UNIT_OF_MEASUREMENT.ACRES
  }, {
    label: i18n.t("application-form.hectares"),
    value: PROPERTY_UNIT_OF_MEASUREMENT.HECTARES
  }],
  propertyHeatingTypeOptions: [{
    label: i18n.t("application-form.electric-baseboard"),
    value: PROPERTY_HEATING_TYPE.ELECTRIC_BASEBOARD
  }, {
    label: i18n.t("application-form.forced-air-gas-oil-elec"),
    value: PROPERTY_HEATING_TYPE.FORCED_AIR_GAS_OIL_ELEC
  }, {
    label: i18n.t("application-form.hot-water-heating"),
    value: PROPERTY_HEATING_TYPE.HOT_WATER_HEATING
  }, {
    label: i18n.t("application-form.other"),
    value: PROPERTY_HEATING_TYPE.OTHER
  }],
  propertyWaterInfoOptions: [{
    label: i18n.t("application-form.municipal"),
    value: PROPERTY_WATER_INFORMATION.MUNICIPAL
  }, {
    label: i18n.t("application-form.well"),
    value: PROPERTY_WATER_INFORMATION.WELL
  }],
  propertySewageTypeOptions: [{
    label: i18n.t("application-form.municipal"),
    value: PROPERTY_SEWAGE_TYPE.MUNICIPAL
  }, {
    label: i18n.t("application-form.septic"),
    value: PROPERTY_SEWAGE_TYPE.SEPTIC
  }, {
    label: i18n.t("application-form.holding-tank"),
    value: PROPERTY_SEWAGE_TYPE.HOLDING_TANK
  }],
  propertyTaxResponsibleOptions: [{
    label: i18n.t("application-form.the-applicant"),
    value: PROPERTY_TAX_RESPONSIBLE.BORROWER
  }, {
    label: i18n.t("application-form.applicant-bank"),
    value: PROPERTY_TAX_RESPONSIBLE.LENDER
  }],
  propertyRentalIncomeSelectOptions: [{
    label: i18n.t("application-form.none"),
    value: PROPERTY_RENTAL_INCOME.NONE
  }, {
    label: i18n.t("application-form.add-perc-to-gross-income"),
    value: PROPERTY_RENTAL_INCOME.ADD_PERC_TO_GROSS_INCOME
  }, {
    label: i18n.t("application-form.red-rental-exp-add-bal"),
    value: PROPERTY_RENTAL_INCOME.RED_RENTAL_EXP_ADD_BAL
  }],
  propertyValueIndexOptions: [{
    label: i18n.t("application-form.purchase-price"),
    value: PROPERTY_VALUE_INDEX.PURCHASE_PRICE
  }, {
    label: i18n.t("application-form.appraised-value"),
    value: PROPERTY_VALUE_INDEX.APPRAISED_VALUE
  }, {
    label: i18n.t("application-form.estimated-value"),
    value: PROPERTY_VALUE_INDEX.ESTIMATED_VALUE
  }],
  yesNoOptions: [{
    value: true,
    label: i18n.t("global.words.yes")
  }, {
    value: false,
    label: i18n.t("global.words.no")
  }],
  applicantLivingSituationOptions: [{
    label: i18n.t("application-form.own-my-own-home"),
    value: APPLICANT_LIVING_SITUATION.OWN
  }, {
    label: i18n.t("application-form.currently-rent"),
    value: APPLICANT_LIVING_SITUATION.RENT
  }, {
    label: i18n.t("application-form.live-with-parents"),
    value: APPLICANT_LIVING_SITUATION.LIVE_WITH_PARENTS
  }, {
    label: i18n.t("application-form.other"),
    value: APPLICANT_LIVING_SITUATION.OTHER
  }],
  maritalStatusOptions: [{
    label: i18n.t("application-form.single"),
    value: APPLICANT_MARITAL_STATUS.SINGLE
  }, {
    label: i18n.t("application-form.married"),
    value: APPLICANT_MARITAL_STATUS.MARRIED
  }, {
    label: i18n.t("application-form.common-law"),
    value: APPLICANT_MARITAL_STATUS.COMMON_LAW
  }, {
    label: i18n.t("application-form.separated"),
    value: APPLICANT_MARITAL_STATUS.SEPARATED
  }, {
    label: i18n.t("application-form.divorced"),
    value: APPLICANT_MARITAL_STATUS.DIVORCED
  }, {
    label: i18n.t("application-form.widowed"),
    value: APPLICANT_MARITAL_STATUS.WIDOWED
  }, {
    label: i18n.t("application-form.other"),
    value: APPLICANT_MARITAL_STATUS.OTHER
  }],
  relationshipToMainApplicantOptions: [{
    label: i18n.t("application-form.spouse"),
    value: APPLICANT_RELATIONSHIP.SPOUSE
  }, {
    label: i18n.t("application-form.common-law"),
    value: APPLICANT_RELATIONSHIP.COMMON_LAW
  }, {
    label: i18n.t("application-form.related-family-member"),
    value: APPLICANT_RELATIONSHIP.RELATED_FAMILY_MEMBER
  }, {
    label: i18n.t("application-form.parent"),
    value: APPLICANT_RELATIONSHIP.PARENT
  }, {
    label: i18n.t("application-form.sibling"),
    value: APPLICANT_RELATIONSHIP.SIBLING
  }, {
    label: i18n.t("application-form.child"),
    value: APPLICANT_RELATIONSHIP.CHILD
  }, {
    label: i18n.t("application-form.grandchild"),
    value: APPLICANT_RELATIONSHIP.GRANDCHILD
  }, {
    label: i18n.t("application-form.grandparent"),
    value: APPLICANT_RELATIONSHIP.GRANDPARENT
  }, {
    label: i18n.t("application-form.other"),
    value: APPLICANT_RELATIONSHIP.OTHER
  }],
  coApplicantTypeOptions: [{
    label: i18n.t("application-form.applicant"),
    value: APPLICANT_TYPE.APPLICANT
  }, {
    label: i18n.t("application-form.co-signer"),
    value: APPLICANT_TYPE.CO_SIGNER
  }, {
    label: i18n.t("application-form.guarantor"),
    value: APPLICANT_TYPE.GUARANTOR
  }],
  languagePreferenceOptions: [{
    label: i18n.t("application-form.english"),
    value: APPLICANT_LANGUAGE_PREFERENCE.ENGLISH
  }, {
    label: i18n.t("application-form.french"),
    value: APPLICANT_LANGUAGE_PREFERENCE.FRENCH
  }],
  applicantIdentificationOptions: [{
    label: i18n.t("application-form.birth-cert"),
    value: APPLICANT_IDENTIFICATION_TYPE.BIRTH_CERT
  }, {
    label: i18n.t("application-form.drivers-license"),
    value: APPLICANT_IDENTIFICATION_TYPE.DRIVERS_LICENSE
  }, {
    label: i18n.t("application-form.social-ins-card"),
    value: APPLICANT_IDENTIFICATION_TYPE.SOCIAL_INS_CARD
  }, {
    label: i18n.t("application-form.passport"),
    value: APPLICANT_IDENTIFICATION_TYPE.PASSPORT
  }, {
    label: i18n.t("application-form.health-ins-card"),
    value: APPLICANT_IDENTIFICATION_TYPE.HEALTH_INSURANCE_CARD
  }, {
    label: i18n.t("application-form.pr-card"),
    value: APPLICANT_IDENTIFICATION_TYPE.PR_CARD
  }, {
    label: i18n.t("application-form.citizenship-cert"),
    value: APPLICANT_IDENTIFICATION_TYPE.CITIZENSHIP_CART
  }, {
    label: i18n.t("application-form.imm-1000-imm-form"),
    value: APPLICANT_IDENTIFICATION_TYPE.IMM_1000
  }, {
    label: i18n.t("application-form.imm-1442-citizenship-and-imm-canada"),
    value: APPLICANT_IDENTIFICATION_TYPE.IMM_1442
  }, {
    label: i18n.t("application-form.other"),
    value: APPLICANT_IDENTIFICATION_TYPE.OTHER
  }],
  applicantOperatingAsOptions: [{
    label: i18n.t("application-form.sole-proprietorship"),
    value: APPLICANT_OPERATING_AS.SOLE_PROPRIETORSHIP
  }, {
    label: i18n.t("application-form.partnership"),
    value: APPLICANT_OPERATING_AS.PARTNERSHIP
  }, {
    label: i18n.t("application-form.corporation"),
    value: APPLICANT_OPERATING_AS.CORPORATION
  }],
  applicantEmploymentTypeOptions: [{
    label: i18n.t("application-form.full-time"),
    value: APPLICANT_EMPLOYMENT_TYPE.FULL_TIME
  }, {
    label: i18n.t("application-form.part-time"),
    value: APPLICANT_EMPLOYMENT_TYPE.PART_TIME
  }, {
    label: i18n.t("application-form.seasonal"),
    value: APPLICANT_EMPLOYMENT_TYPE.SEASONAL
  }],
  applicantOccupationOptions: [{
    label: i18n.t("application-form.self-employed"),
    value: APPLICANT_OCCUPATION.SELF_EMPLOYED
  }, {
    label: i18n.t("application-form.management"),
    value: APPLICANT_OCCUPATION.MANAGEMENT
  }, {
    label: i18n.t("application-form.clerical"),
    value: APPLICANT_OCCUPATION.CLERICAL
  }, {
    label: i18n.t("application-form.labour-tradesperson"),
    value: APPLICANT_OCCUPATION.LABOUR_TRADESPERSON
  }, {
    label: i18n.t("application-form.retired"),
    value: APPLICANT_OCCUPATION.RETIRED
  }, {
    label: i18n.t("application-form.professional"),
    value: APPLICANT_OCCUPATION.PROFESSIONAL
  }, {
    label: i18n.t("application-form.other"),
    value: APPLICANT_OCCUPATION.OTHER
  }],
  applicantIncomeTypeOptions: [{
    label: i18n.t("application-form.salary"),
    value: APPLICANT_INCOME_TYPE.SALARY
  }, {
    label: i18n.t("application-form.hourly"),
    value: APPLICANT_INCOME_TYPE.HOURLY
  }, {
    label: i18n.t("application-form.hourly-and-commissions"),
    value: APPLICANT_INCOME_TYPE.HOURLY_AND_COMMISSIONS
  }, {
    label: i18n.t("application-form.commissions"),
    value: APPLICANT_INCOME_TYPE.COMMISSIONS
  }, {
    label: i18n.t("application-form.self-employed"),
    value: APPLICANT_INCOME_TYPE.SELF_EMPLOYED
  }, {
    label: i18n.t("application-form.other-employment-income"),
    value: APPLICANT_INCOME_TYPE.OTHER_EMPLOYMENT_INCOME
  }],
  applicantIndustrySectorOptions: [{
    label: i18n.t("application-form.construction"),
    value: APPLICANT_INDUSTRY_SECTOR.CONSTRUCTION
  }, {
    label: i18n.t("application-form.government"),
    value: APPLICANT_INDUSTRY_SECTOR.GOVERNMENT
  }, {
    label: i18n.t("application-form.health"),
    value: APPLICANT_INDUSTRY_SECTOR.HEALTH
  }, {
    label: i18n.t("application-form.education"),
    value: APPLICANT_INDUSTRY_SECTOR.EDUCATION
  }, {
    label: i18n.t("application-form.high-tech"),
    value: APPLICANT_INDUSTRY_SECTOR.HIGH_TECH
  }, {
    label: i18n.t("application-form.retail-sales"),
    value: APPLICANT_INDUSTRY_SECTOR.RETAIL_SALES
  }, {
    label: i18n.t("application-form.leisure-entertainment"),
    value: APPLICANT_INDUSTRY_SECTOR.LEISURE_ENTERTAINMENT
  }, {
    label: i18n.t("application-form.banking-finance"),
    value: APPLICANT_INDUSTRY_SECTOR.BANKING_FINANCE
  }, {
    label: i18n.t("application-form.transportation"),
    value: APPLICANT_INDUSTRY_SECTOR.TRANSPORTATION
  }, {
    label: i18n.t("application-form.services"),
    value: APPLICANT_INDUSTRY_SECTOR.SERVICES
  }, {
    label: i18n.t("application-form.manufacturing"),
    value: APPLICANT_INDUSTRY_SECTOR.MANUFACTURING
  }, {
    label: i18n.t("application-form.farming-natural-resources"),
    value: APPLICANT_INDUSTRY_SECTOR.FARMING_NATURAL_RESOURCES
  }, {
    label: i18n.t("application-form.varies"),
    value: APPLICANT_INDUSTRY_SECTOR.VARIES
  }, {
    label: i18n.t("application-form.other"),
    value: APPLICANT_INDUSTRY_SECTOR.OTHER
  }],
  applicantIncomePeriodOptions: [{
    label: i18n.t("application-form.annually"),
    value: APPLICANT_INCOME_PERIOD.ANNUAL
  }, {
    label: i18n.t("application-form.semi-annually"),
    value: APPLICANT_INCOME_PERIOD.SEMI_ANNUAL
  }, {
    label: i18n.t("application-form.quarterly"),
    value: APPLICANT_INCOME_PERIOD.QUARTERLY
  }, {
    label: i18n.t("application-form.monthly"),
    value: APPLICANT_INCOME_PERIOD.MONTHLY
  }, {
    label: i18n.t("application-form.semi-monthly"),
    value: APPLICANT_INCOME_PERIOD.SEMI_MONTHLY
  }, {
    label: i18n.t("application-form.bi-weekly"),
    value: APPLICANT_INCOME_PERIOD.BI_WEEKLY
  }, {
    label: i18n.t("application-form.weekly"),
    value: APPLICANT_INCOME_PERIOD.WEEKLY
  }],
  additionalIncomeTypeOptions: [{
    label: i18n.t("application-form.child-support"),
    value: ADDITIONAL_INCOME_TYPE.CHILD_SUPPORT
  }, {
    label: i18n.t("application-form.pension"),
    value: ADDITIONAL_INCOME_TYPE.PENSION
  }, {
    label: i18n.t("application-form.interest-income"),
    value: ADDITIONAL_INCOME_TYPE.INTEREST_INCOME
  }, {
    label: i18n.t("application-form.alimony"),
    value: ADDITIONAL_INCOME_TYPE.ALIMONY
  }, {
    label: i18n.t("application-form.other"),
    value: ADDITIONAL_INCOME_TYPE.OTHER
  }],
  assetTypeOptions: [{
    label: i18n.t("application-form.savings"),
    value: ASSET_TYPE.SAVINGS
  }, {
    label: i18n.t("application-form.rrsp"),
    value: ASSET_TYPE.RRSP
  }, {
    label: i18n.t("application-form.gift"),
    value: ASSET_TYPE.GIFT
  }, {
    label: i18n.t("application-form.vehicle"),
    value: ASSET_TYPE.VEHICLE
  }, {
    label: i18n.t("application-form.stocks-bonds-mutual"),
    value: ASSET_TYPE.STOCKS_BONDS_MUTUAL
  }, {
    label: i18n.t("application-form.household-goods"),
    value: ASSET_TYPE.HOUSEHOLD_GOODS
  }, {
    label: i18n.t("application-form.life-insurance"),
    value: ASSET_TYPE.LIFE_INSURANCE
  }, {
    label: i18n.t("application-form.deposit-on-purchase"),
    value: ASSET_TYPE.DEPOSIT_ON_PURCHASE
  }, {
    label: i18n.t("application-form.other"),
    value: ASSET_TYPE.OTHER
  }],
  liabilityTypeOptions: [{
    label: i18n.t("application-form.mortgage"),
    value: LIABILITY_TYPE.MORTGAGE
  }, {
    label: i18n.t("application-form.credit-card"),
    value: LIABILITY_TYPE.CREDIT_CARD
  }, {
    label: i18n.t("application-form.personal-loan"),
    value: LIABILITY_TYPE.PERSONAL_LOAN
  }, {
    label: i18n.t("application-form.auto-loan"),
    value: LIABILITY_TYPE.AUTO_LOAN
  }, {
    label: i18n.t("application-form.alimony"),
    value: LIABILITY_TYPE.ALIMONY
  }, {
    label: i18n.t("application-form.child-support"),
    value: LIABILITY_TYPE.CHILD_SUPPORT
  }, {
    label: i18n.t("application-form.student-loan"),
    value: LIABILITY_TYPE.STUDENT_LOAN
  }, {
    label: i18n.t("application-form.wage-garnishment"),
    value: LIABILITY_TYPE.WAGE_GARNISHMENT
  }, {
    label: i18n.t("application-form.unsecured-line-of-credit"),
    value: LIABILITY_TYPE.UNSECURED_LINE_OF_CREDIT
  }, {
    label: i18n.t("application-form.secured-line-of-credit"),
    value: LIABILITY_TYPE.SECURED_LINE_OF_CREDIT
  }, {
    label: i18n.t("application-form.income-tax"),
    value: LIABILITY_TYPE.INCOME_TAX
  }, {
    label: i18n.t("application-form.mortgage-rental-property"),
    value: LIABILITY_TYPE.MORTGAGE_RENTAL_PROPERTY
  }, {
    label: i18n.t("application-form.lease"),
    value: LIABILITY_TYPE.LEASE
  }, {
    label: i18n.t("application-form.auto-lease"),
    value: LIABILITY_TYPE.AUTO_LEASE
  }, {
    label: i18n.t("application-form.rent"),
    value: LIABILITY_TYPE.RENT,
    disabled: true
  }, {
    label: i18n.t("application-form.other"),
    value: LIABILITY_TYPE.OTHER
  }],
  liabilityPayoffOptions: [{
    label: i18n.t("application-form.prior-to-advance"),
    value: LIABILITY_PAYOFF.PRIOR_TO_ADVANCE
  }, {
    label: i18n.t("application-form.from-proceeds"),
    value: LIABILITY_PAYOFF.FROM_PROCEEDS
  }, {
    label: i18n.t("application-form.other"),
    value: LIABILITY_PAYOFF.OTHER
  }],
  downPaymentSourceOptions: [{
    label: i18n.t("application-form.sales-of-existing-property"),
    value: MORTGAGE_DOWNPAYMENT_SOURCE.SALES_OF_EXISTING_PROPERTY
  }, {
    label: i18n.t("application-form.personal-cash"),
    value: MORTGAGE_DOWNPAYMENT_SOURCE.PERSONAL_CASH
  }, {
    label: i18n.t("application-form.rrsp"),
    value: MORTGAGE_DOWNPAYMENT_SOURCE.RRSP
  }, {
    label: i18n.t("application-form.borrowed-against-liquid-assets"),
    value: MORTGAGE_DOWNPAYMENT_SOURCE.BORROWED_AGAINST_LIQUID_ASSETS
  }, {
    label: i18n.t("application-form.gift"),
    value: MORTGAGE_DOWNPAYMENT_SOURCE.GIFT
  }, {
    label: i18n.t("application-form.sweat-equity"),
    value: MORTGAGE_DOWNPAYMENT_SOURCE.SWEAT_EQUITY
  }, {
    label: i18n.t("application-form.existing-equity"),
    value: MORTGAGE_DOWNPAYMENT_SOURCE.EXISTING_EQUITY
  }, {
    label: i18n.t("application-form.secondary-financing"),
    value: MORTGAGE_DOWNPAYMENT_SOURCE.SECONDARY_FINANCING
  }, {
    label: i18n.t("application-form.grants"),
    value: MORTGAGE_DOWNPAYMENT_SOURCE.GRANTS
  }, {
    label: i18n.t("application-form.other"),
    value: MORTGAGE_DOWNPAYMENT_SOURCE.OTHER
  }],
  mortgageRequestedOptions: [{
    label: i18n.t("application-form.requested"),
    value: MORTGAGE_REQUESTED_TYPE.REQUESTED
  }, {
    label: i18n.t("application-form.existing"),
    value: MORTGAGE_REQUESTED_TYPE.EXISTING
  }],
  mortgageLoanTypeOptions: [{
    label: i18n.t("application-form.mortgage"),
    value: MORTGAGE_LOAN_TYPE.MORTGAGE
  }, {
    label: i18n.t("application-form.secured-loc"),
    value: MORTGAGE_LOAN_TYPE.SECURED_LOC
  }],
  mortgageTypeOptions: [{
    label: i18n.t("application-form.first"),
    value: MORTGAGE_TYPE.FIRST
  }, {
    label: i18n.t("application-form.second"),
    value: MORTGAGE_TYPE.SECOND
  }, {
    label: i18n.t("application-form.third"),
    value: MORTGAGE_TYPE.THIRD
  }],
  lineOfBusinessOptions: [{
    label: "A",
    value: MORTGAGE_LINE_OF_BUSINESS.A
  }, {
    label: "B",
    value: MORTGAGE_LINE_OF_BUSINESS.B
  }, {
    label: "C",
    value: MORTGAGE_LINE_OF_BUSINESS.C
  }],
  locRepaymentOptions: [{
    label: "5/20",
    value: MORTGAGE_LOC_REPAYMENT.FIVE_TWENTY
  }, {
    label: "10/15",
    value: MORTGAGE_LOC_REPAYMENT.TEN_FIFTEEN
  }],
  mortgageRateTypeOptions: [{
    label: i18n.t("application-form.fixed"),
    value: MORTGAGE_RATE_TYPE.FIXED
  }, {
    label: i18n.t("application-form.adjustable"),
    value: MORTGAGE_RATE_TYPE.ADJUSTABLE
  }, {
    label: i18n.t("application-form.capped-variable"),
    value: MORTGAGE_RATE_TYPE.CAPPED_VARIABLE
  }, {
    label: i18n.t("application-form.variable"),
    value: MORTGAGE_RATE_TYPE.VARIABLE
  }, {
    label: i18n.t("application-form.buy-down"),
    value: MORTGAGE_RATE_TYPE.BUY_DOWN
  }],
  mortgageTermTypeOptions: [{
    label: i18n.t("application-form.closed"),
    value: MORTGAGE_TERM_TYPE.CLOSED
  }, {
    label: i18n.t("application-form.open"),
    value: MORTGAGE_TERM_TYPE.OPEN
  }, {
    label: i18n.t("application-form.convertible"),
    value: MORTGAGE_TERM_TYPE.CONVERTIBLE
  }],
  mortgageFrequencyOptions: [{
    label: i18n.t("application-form.monthly"),
    value: MORTGAGE_FREQUENCY.MONTHLY
  }, {
    label: i18n.t("application-form.semi-monthly"),
    value: MORTGAGE_FREQUENCY.SEMI_MONTHLY
  }, {
    label: i18n.t("application-form.biweekly"),
    value: MORTGAGE_FREQUENCY.BIWEEKLY
  }, {
    label: i18n.t("application-form.accelerated-biweekly"),
    value: MORTGAGE_FREQUENCY.ACCELERATED_BIWEEKLY
  }, {
    label: i18n.t("application-form.weekly"),
    value: MORTGAGE_FREQUENCY.WEEKLY
  }, {
    label: i18n.t("application-form.accelerated-weekly"),
    value: MORTGAGE_FREQUENCY.ACCELERATED_WEEKLY
  }],
  mortgageCompoundingPeriodOptions: [{
    label: i18n.t("application-form.semi-annually"),
    value: MORTGAGE_COMPOUNDING_PERIOD.SEMI_ANNUALLY
  }, {
    label: i18n.t("application-form.monthly"),
    value: MORTGAGE_COMPOUNDING_PERIOD.MONTHLY
  }],
  mortgageNoteCategoryOptions: [{
    label: i18n.t("application-form.general"),
    value: MORTGAGE_NOTE_CATEGORY.GENERAL
  }, {
    label: i18n.t("application-form.admin"),
    value: MORTGAGE_NOTE_CATEGORY.ADMIN
  }, {
    label: i18n.t("application-form.source-of-business"),
    value: MORTGAGE_NOTE_CATEGORY.SOURCE_OF_BUSINESS
  }, {
    label: i18n.t("application-form.decisioning"),
    value: MORTGAGE_NOTE_CATEGORY.DECISIONING
  }, {
    label: i18n.t("application-form.mi-response"),
    value: MORTGAGE_NOTE_CATEGORY.MI_RESPONSE
  }, {
    label: i18n.t("application-form.deal-ingestion"),
    value: MORTGAGE_NOTE_CATEGORY.DEAL_INGESTION
  }],
  mortgagePayoffOptions: [{
    label: i18n.t("application-form.prior-to-advance"),
    value: MORTGAGE_PAYOFF.PRIOR_TO_ADVANCE
  }, {
    label: i18n.t("application-form.from-proceeds"),
    value: MORTGAGE_PAYOFF.FROM_PROCEEDS
  }, {
    label: i18n.t("application-form.other"),
    value: MORTGAGE_PAYOFF.OTHER
  }],
  mortgageInsuranceProviderOptions: [{
    label: "CMHC",
    value: MORTGAGE_INSURANCE_PROVIDER.CMHC
  }, {
    label: i18n.t("application-form.genworth"),
    value: MORTGAGE_INSURANCE_PROVIDER.GENWORTH
  }, {
    label: i18n.t("application-form.canada-guaranty"),
    value: MORTGAGE_INSURANCE_PROVIDER.CANADA_GUARANTY
  }],
  canadaProvinceOptions: [{
    value: CANADA_PROVINCE.ALBERTA,
    label: i18n.t("address.provinces.alberta")
  }, {
    value: CANADA_PROVINCE.BRITISH_COLUMBIA,
    label: i18n.t("address.provinces.britishColumbia")
  }, {
    value: CANADA_PROVINCE.MANITOBA,
    label: i18n.t("address.provinces.manitoba")
  }, {
    value: CANADA_PROVINCE.NEW_BRUNSWICK,
    label: i18n.t("address.provinces.newBrunswick")
  }, {
    value: CANADA_PROVINCE.NEWFOUNDLAND_AND_LABRADOR,
    label: i18n.t("address.provinces.newfoundlandAndLabrador")
  }, {
    value: CANADA_PROVINCE.NOVA_SCOTIA,
    label: i18n.t("address.provinces.novaScotia")
  }, {
    value: CANADA_PROVINCE.NORTHWEST_TERRITORIES,
    label: i18n.t("address.provinces.northwestTerritories")
  }, {
    value: CANADA_PROVINCE.NUNAVUT,
    label: i18n.t("address.provinces.nunavut")
  }, {
    value: CANADA_PROVINCE.ONTARIO,
    label: i18n.t("address.provinces.ontario")
  }, {
    value: CANADA_PROVINCE.PRINCE_EDWARD_ISLAND,
    label: i18n.t("address.provinces.princeEdwardIsland")
  }, {
    value: CANADA_PROVINCE.QUÉBEC,
    label: i18n.t("address.provinces.quebec")
  }, {
    value: CANADA_PROVINCE.SASKATCHEWAN,
    label: i18n.t("address.provinces.saskatchewan")
  }, {
    value: CANADA_PROVINCE.YUKON,
    label: i18n.t("address.provinces.yukon")
  }]
});
export const GLOBAL_APPLICATION_FIELD_OPTIONS = {
  canadaProvinceOptions: APPLICATION_FIELD_OPTIONS().canadaProvinceOptions
};